(function () {
  'use strict';

  angular.module('ringbaPortal').component('ivrParameter', {
    bindings: {
      nodeId: '<',
      parameter: '<',
      parameterErrors: '<',
      parameterValues: '<',
      paramNamePrefix: '<',
      onParamChange: '<',
      clearOptionalSubType: '<',
      updateConnections: '<',
      activateTreeSelectMode: '&',
      gotoDestinationNode: '<',
      highlightNode: '<',
      uploadAudioFile: '<',
      ivrFiles: '<'
    },
    controller: ivrParameterController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/ivr/ivr-parameter.view.html'
  });

  function ivrParameterController(
    _,
    $filter,
    $injector,
    $interval,
    accountsService,
    infoService
  ) {
    'ngInject';
    const vm = this;
    let keyRefreshInterval;

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.$onChanges = onChanges;
    vm.valueChanged = valueChanged;
    vm.toggleOptionalSubtype = toggleOptionalSubtype;
    vm.toggleGroupSubtype = toggleGroupSubtype;
    vm.uploadAudio = uploadAudio;
    vm.setHours = setHours;

    function onInit() {
      _loadTimeZones();
      vm.internalParam = angular.copy(vm.parameter);

      vm.isSelectGotoNodeParameter = vm.internalParam.name.indexOf('goToNodeId') > -1;

      vm.isTimeZoneParameter = vm.internalParam.name.indexOf('timeZoneId') > -1;

      vm.isHourOfOperationParameter = vm.internalParam.name.indexOf('hourseOfOperationSetting') > -1;

      vm.isJsNodeParameter = vm.internalParam.name.indexOf('script') > -1;

      if (vm.internalParam.type === 'key') {
        _refreshKey();
        keyRefreshInterval = $interval(_refreshKey, 15000);
      }

      if (vm.paramNamePrefix) {
        // TODO: Fix for groups not nested in subtypes
        if (vm.internalParam.type === 'group') {
          vm.internalParam.name = vm.paramNamePrefix;
        } else {
          vm.internalParam.name = vm.paramNamePrefix + '.' + vm.internalParam.name;
        }
        vm.isPlayUrlParameter = vm.internalParam.name.indexOf('play.URL') > -1;
        vm.isSayParameter = vm.internalParam.name.indexOf('.say') > -1;
      }
      if (vm.parameterValues) {
        vm.parameterValue = angular.copy(_.get(vm.parameterValues, vm.internalParam.name));
        if (vm.internalParam.type === 'sub_type') {
          vm.optionalSubTypeExpanded = typeof vm.internalParam.groupOptional != 'undefined' && !vm.internalParam.groupOptional;
          _.forOwn(vm.parameterValues, function (value, key) {
            if (key.startsWith(vm.internalParam.name)) {
              vm.optionalSubTypeExpanded = true;
            }
          });
        }
        if (vm.isPlayUrlParameter) {
          vm.internalParam.displayName = 'Audio File';
          _setSelectedIvrFileForPlayUrl();
        }
        _setActiveGroupOption();
        _setParamError();
      }
      if (vm.internalParam.type === 'list' && !vm.parameterValue && vm.internalParam.defaultValue) {
        vm.parameterValue = vm.internalParam.defaultValue;
      }

      // The backend used to treat bool values as strings, this check is so the UI recogenizes the value in the toggle
      if (vm.internalParam.type === 'bool' && vm.parameterValue == 'true') {
        vm.parameterValue = true;
      }
      // We need assign the default to the param if it doesnt have a value
      if (vm.internalParam.type === 'bool' && vm.parameterValue == null) {
        vm.parameterValue = vm.internalParam.defaultValue;
      }

      _setDisplayNames();

      if (vm.isSelectGotoNodeParameter) {
        vm.internalParam.displayName = $filter('translate')('IVR_GOTO_NODE_LABEL');
        vm.internalParam.description = $filter('translate')('IVR_GOTO_NODE_LABEL_TT');
      }
      if (vm.isPlayUrlParameter) {
        vm.internalParam.description = $filter('translate')('IVR_PLAY_URL_TOOLTIP');
      }
      vm.groupOptional = typeof vm.internalParam.groupOptional == 'undefined' || vm.internalParam.groupOptional;

      vm.isPlainStringParameter = !vm.isHourOfOperationParameter && !vm.isTimeZoneParameter && !vm.isSayParameter && !vm.isPlayUrlParameter && !vm.isSelectGotoNodeParameter && !vm.isJsNodeParameter;

      if (vm.parameterErrors) {
        _setParamError();
      }
    }

    function onChanges(changes) {
      if (changes.parameterValues && !changes.parameterValues.isFirstChange()) {
        const value = _.get(vm.parameterValues, vm.internalParam.name);
        if (value) {
          vm.parameterValue = angular.copy(value);
          if (vm.isPlayUrlParameter) {
            _setSelectedIvrFileForPlayUrl();
          }
        }
        _setActiveGroupOption();
      }
      if (changes.parameterErrors) {
        _setParamError();
      }
    }

    function onDestroy() {
      $interval.cancel(keyRefreshInterval);
    }

    function valueChanged(sel) {
      if (sel && vm.isPlayUrlParameter) {
        sel.resetSearchInput = false;
        _getUrlForSelectedIvrFile(sel);
      }
      if (_.get(vm.parameterValues, vm.internalParam.name) != vm.parameterValue) {
        vm.onParamChange(angular.copy(vm.internalParam), angular.copy(vm.parameterValue));
      }
    }

    function toggleOptionalSubtype() {
      if (!vm.optionalSubTypeExpanded) {
        vm.clearOptionalSubType(vm.internalParam);
      } else {
        vm.updateConnections();
      }
    }

    function toggleGroupSubtype(option) {
      vm.selectedGroupOption = option.name;
      vm.updateConnections();
    }

    function setHours(hourOfOperation) {
      vm.parameterValue = hourOfOperation;
      vm.valueChanged();
    }

    function uploadAudio(file, errFiles) {
      vm.fileUpload = file;
      vm.error = false;
      if (errFiles && errFiles[0]) {
        const errFile = errFiles[0];
        vm.error = { errorMessage: errFile.name + ' ' + errFile.$error + ' ' + errFile.$errorParam };
      }
      if (file) {
        vm.disableParam = true;
        vm.info = 'Uploading file...';
        vm.uploadAudioFile(vm.nodeId, file)
          .then(function (ivrFile) {
            if (ivrFile && ivrFile.publicUrl) {
              vm.selectedIvrFile = ivrFile;
              valueChanged({});
            }
          })
          .finally(function () {
            vm.disableParam = vm.info = false;
          });
      }
    }

    function _refreshKey() {
      // e.g. 'callPlanService'
      const serviceName = _.camelCase(vm.internalParam.keyType + ' Service');
      const serviceFunction = _.camelCase('get ' + vm.internalParam.keyType + 's');
      const service = $injector.get(serviceName);
      service[serviceFunction].call(null, accountsService.currentAccountId).then(function (data) {
        vm.values = data;
      });
    }


    function _setActiveGroupOption() {
      if (vm.internalParam.type === 'group') {
        vm.selectedGroupOption = vm.internalParam.options[0].name;
        const isAGroupOption = _.keyBy(vm.internalParam.options, 'name');
        const groupParentSubTypeValue = _.get(vm.parameterValues, vm.internalParam.groupParentSubtypeName);
        if (groupParentSubTypeValue) {
          _.forOwn(groupParentSubTypeValue, function (value, key) {
            if (isAGroupOption[key]) {
              vm.selectedGroupOption = key;
            }
          });
        }
      }
    }

    function _setDisplayNames() {
      if (vm.internalParam != null && vm.internalParam.displayName != null) {
        if (vm.internalParam.displayName === 'Number Of Digits') {
          vm.internalParam.displayName = 'Max Number of Digits';
        }
        vm.internalParam.displayName = vm.internalParam.displayName.replace(' Of ', ' of ');
        vm.internalParam.displayName = vm.internalParam.displayName.replace(' On ', ' on ');
        vm.internalParam.displayName = vm.internalParam.displayName.replace(' In ', ' in ');
        vm.internalParam.displayName = vm.internalParam.displayName.replace('Time Out', 'Timeout');
      }
    }

    function _setParamError() {
      if (vm.parameterErrors && vm.internalParam) {
        if (vm.internalParam.type == 'group' && vm.internalParam.options && vm.internalParam.options.length) {
          vm.error = angular.copy(vm.parameterErrors[vm.internalParam.name + '.' + vm.internalParam.options[0].group]);
        } else {
          vm.error = angular.copy(vm.parameterErrors[vm.internalParam.name]);
        }
      }
      if (vm.error && vm.internalParam && !vm.parameterErrors) {
        vm.error = false;
      }

      if (vm.error && vm.isSelectGotoNodeParameter) {
        vm.error.errorMessage = $filter('translate')('IVR_GOTO_NODE_ERROR_MESSAGE');
      }
    }

    function _setSelectedIvrFileForPlayUrl() {
      if (vm.parameterValue && vm.parameterValue !== '') {
        vm.error = false;
        vm.selectedIvrFile = _.find(vm.ivrFiles, { publicUrl: vm.parameterValue });
        if (typeof vm.selectedIvrFile === 'undefined') {
          vm.selectedIvrFile = _createUserEnteredUrlIvrFile(vm.parameterValue);
          vm.ivrFiles.push(vm.selectedIvrFile);
        }
      }
    }

    function _getUrlForSelectedIvrFile(sel) {
      if (sel.search && sel.search !== '' && !sel.clickTriggeredSelect) {
        if (!sel.selected || sel.selected.originalFileName != sel.search) {
          //Search for an existing entry for the given name
          let userURL = _.find(vm.ivrFiles, { publicUrl: sel.search });
          if (typeof userURL === 'undefined') {
            //Create a new entry since one does not exist
            userURL = _createUserEnteredUrlIvrFile(sel.search);
            vm.ivrFiles.push(userURL);
          }
          //Make the found or created entry the selected one
          sel.selected = userURL;
          vm.parameterValue = userURL.publicUrl;
        }
      } if (vm.selectedIvrFile) {
        sel.resetSearchInput = true;
        vm.parameterValue = vm.selectedIvrFile.publicUrl;
      }
    }

    function _createUserEnteredUrlIvrFile(userEnteredUrl) {
      return { publicUrl: userEnteredUrl, originalFileName: userEnteredUrl };
    }

    function _loadTimeZones() {
      infoService.getTimeZones()
        .then(function (response) {
          vm.timeZones = response.data;
        });
    }
  }
})();
